import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import { useForm } from 'react-hook-form';
// import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import Button from 'src/components/controls/forms/redesign/FormButton';
import InvoiceDoc from '../models/InvoiceDoc';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import InvoiceType from 'src/components/project-billing/models/InvoiceType';
import { AnyObject } from 'final-form';
import Fieldset from '../components/FieldSetComponent';

interface IInvoiceDocumentCreationDialogProps {
    dialogName: string;
    handleConfirm?: (data: Array<InvoiceDoc>, merge: number) => void;
    hideDialog: () => void;
    invoiceNumber?: string;
    invoicesDocTypes?: Array<InvoiceType> | null;
    assignToNumber?: string;
}

const InvoiceDocumentCreationDialog = (props: IInvoiceDocumentCreationDialogProps) => {
    const { register, errors, handleSubmit, getValues, setError, clearErrors, setValue, watch } = useForm({
        defaultValues: {
            mergeType: '3',
            documentTypes: null,
            invoiceDocTypes: [true, true, true, true, true, true]
        }
    });
    const [documents, setDocuments] = useState<Array<InvoiceDoc>>([]);
    const formInvoiceDocTypes = watch('invoiceDocTypes');
    const formMergeType = watch('mergeType');

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        const toMerge = getValues('mergeType');
        if (!!documents && documents.length > 0) {
            props.handleConfirm(documents, Number(toMerge));
        }
    }, [documents]);

    useEffect(() => {
        const mergeType = getValues('mergeType');
        if (Array.isArray(formInvoiceDocTypes) && Array.isArray(props?.invoicesDocTypes) && mergeType === '3') {
            const allTrue = (formInvoiceDocTypes as Array<boolean>).every((item) => item === true );
            if (!allTrue) {
                props.invoicesDocTypes.forEach((idt: InvoiceType, index: number) => idt.documentType !== 'INVGROUP' &&
                    idt.documentType !== 'MERGE' ? setValue(`invoiceDocTypes[${index}]`, true) : null);
            }
        } else if (Array.isArray(formInvoiceDocTypes) && Array.isArray(props?.invoicesDocTypes)) {
            props.invoicesDocTypes.forEach((idt: InvoiceType, index: number) => idt.documentType !== 'INVGROUP' &&
                    idt.documentType !== 'MERGE' ? setValue(`invoiceDocTypes[${index}]`, false) : null);
        }
    }, [formMergeType]);

    useEffect(() => {
        if (Array.isArray(props?.invoicesDocTypes)) {
            props.invoicesDocTypes.forEach((idt: InvoiceType, index: number) => idt.documentType !== 'INVGROUP' &&
                idt.documentType !== 'MERGE' ? setValue(`invoiceDocTypes[${index}]`, true) : null);
        }
    }, [props?.invoicesDocTypes]);

    const onCreate = () => {
        console.log('onCreate InvoiceDocumentCreationDialog');
    };

    const onSubmit = async (formData: AnyObject) => {
        const anyChecked = formData?.invoiceDocTypes?.some((v: boolean) => v === true);

        if (!anyChecked) {
            setError('documentTypes', {
                type: 'manual',
                message: 'Please select at least one document to generate.'
            });
            return;
        }

        clearErrors('documentTypes');
        const documentTypes = formData.invoiceDocTypes;
        const docsToGenerate = new Array<InvoiceDoc>();
        if (Array.isArray(props?.invoicesDocTypes) &&
            Array.isArray(documentTypes)) {
            documentTypes.forEach((dt, index) => {
                let documentType = props.invoicesDocTypes[index]?.documentType;
                if (documentType !== 'MERGE' && documentType !== 'INVGROUP' && dt) {
                    const mergeDoc = new InvoiceDoc();
                    mergeDoc.documentType = documentType;
                    docsToGenerate.push(mergeDoc);
                }
            });
        }
        if (docsToGenerate.length > 0) {
            onAddDocuments(docsToGenerate);
        }
    };

/*     const onSubmit = async (formData: AnyObject) => {
        const documentTypes = formData.invoiceDocTypes;
        const docsToGenerate = new Array<InvoiceDoc>();
        if (formData?.mergeType === '1' &&
            Array.isArray(props?.invoicesDocTypes) &&
            Array.isArray(documentTypes)) {
            documentTypes.forEach((dt, index) => {
                let documentType = props.invoicesDocTypes[index]?.documentType;
                if (documentType !== 'MERGE' && dt) {
                    const mergeDoc = new InvoiceDoc();
                    mergeDoc.documentType = documentType;
                    docsToGenerate.push(mergeDoc);
                }
            });
        } else if (formData?.mergeType === '2' && Array.isArray(props?.invoicesDocTypes)) {
            const mergeDoc = new InvoiceDoc();
            mergeDoc.documentType = '7';
            docsToGenerate.push(mergeDoc);
        } else if (formData?.mergeType === '3' && Array.isArray(props?.invoicesDocTypes)) {
            documentTypes.length = 0;
            props.invoicesDocTypes.forEach((idt) => {
                const mergeDoc = new InvoiceDoc();
                mergeDoc.documentType = idt.documentType;
                docsToGenerate.push(mergeDoc);
            });
        }
        onAddDocuments(docsToGenerate);
    }; */

    const onAddDocuments = async (documentTypes: Array<InvoiceType>) => {
        const newDocuments = new Array<InvoiceDoc>();
        documentTypes.map((dt) => {
            if (dt) {
                const invoiceDoc = new InvoiceDoc();
                invoiceDoc.documentType = dt.documentType;
                invoiceDoc.fileDate = new Date();
                invoiceDoc.source = 'C';
                newDocuments.push(invoiceDoc);
            }
        });

        setDocuments(newDocuments);
    };

    const getCheckState = () => {
        const mergeType = getValues('mergeType');
        if (mergeType === '3') {
            return true;
        } else {
            return false;
        }
    };

    const renderDocumeTypeOptions = () => {
        return (
            <>
                {props?.invoicesDocTypes && props?.invoicesDocTypes.map((idt, index) => {
                    return (
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '1rem'}} key={index}>
                            {idt.documentType !== 'MERGE' && idt.documentType !== 'INVGROUP' && <RHFCheckbox
                                name={`invoiceDocTypes[${index}]`}
                                label={idt.typeName}
                                register={register}
                                errors={errors}
                                bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        clearErrors('documentTypes');
                                    }
                                }}
                                defaultChecked={getCheckState()}
                            />}
                            {idt.description === 'BOP Time Sheets' && <RHFInputBox
                                className={''}
                                bodyStyle={{whiteSpace: 'nowrap', height: '2.0rem', display: 'flex', alignItems: 'center', margin: '0.8rem 0 0 2rem'}}
                                labelOnLeft={true}
                                style={{ height: '2.0rem', width: '30%', marginLeft: '0.5rem' }}
                                name="assignBop"
                                label="assign to #"
                                defaultVal={props?.assignToNumber}
                            />}
                        </div>
                    );
                })}
            </>
        );
    };

/*     const displayDocumentsToAdd = () => {
        if (!!documents && documents.length > 0) {
            return (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                <tr>
                    <th style={{ width: '25%', textAlign: 'left', borderBottom: '1px solid #ccc', padding: '4px' }}>Document Type</th>
                    <th style={{ width: '25%', textAlign: 'left', borderBottom: '1px solid #ccc', padding: '4px' }}>Document Category</th>
                    <th style={{ width: '25%', textAlign: 'left', borderBottom: '1px solid #ccc', padding: '4px' }}>Invoice #</th>
                    <th style={{ width: '25%', textAlign: 'left', borderBottom: '1px solid #ccc', padding: '4px' }}>Client #</th>
                </tr>
                </thead>
                <tbody>
                {documents.map((doc: InvoiceDocument, index: number) => (
                    <tr key={index}>
                    <th style={{ width: '25%', padding: '4px', borderBottom: '1px solid #eee', fontWeight: 'normal' }}>
                        {doc?.documentType ?? ''}
                    </th>
                    <th style={{ width: '25%', padding: '4px', borderBottom: '1px solid #eee', fontWeight: 'normal' }}>
                        {doc?.documentCategory ?? ''}
                    </th>
                    <th style={{ width: '25%', padding: '4px', borderBottom: '1px solid #eee', fontWeight: 'normal' }}>
                        {doc?.invoiceNumber ?? ''}
                    </th>
                    <th style={{ width: '25%', padding: '4px', borderBottom: '1px solid #eee', fontWeight: 'normal' }}>
                        {doc?.clientNumber ?? ''}
                    </th>
                    </tr>
                ))}
                </tbody>
            </table>
            );
        } else {
            return <div>No Documents</div>;
        }
    };  */

    return (
        <Dialog title="Generate Invoice Documents" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '20%' }}>
            <form style={{width: '100%'}} onSubmit={handleSubmit(onSubmit)}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'left', width: '100%'}}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left'}}>
                            <Fieldset
                                label={'Merge Type'}
                                style={{display: 'inline-flex', alignItems: 'center', padding: '0px 6px 2px 1px'}}
                            >
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                    <input
                                        title={'Generate & Merge the selected documents'}
                                        type={'radio'}
                                        name={'mergeType'}
                                        ref={register}
                                        value={'1'}
                                        defaultValue={'3'}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                clearErrors('documentTypes');
                                            }
                                        }}
                                    />
                                    Selected
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                    <input
                                        title={'Generate & Merge existing documents'}
                                        type={'radio'}
                                        name={'mergeType'}
                                        ref={register}
                                        value={'2'}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                clearErrors('documentTypes');
                                            }
                                        }}
                                    />
                                    Existing
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                    <input
                                        title={'Generate & Merge all documents'}
                                        type={'radio'}
                                        name={'mergeType'}
                                        ref={register}
                                        value={'3'}
                                        defaultChecked={true}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                clearErrors('documentTypes');
                                            }
                                        }}
                                    />
                                    All
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                    <input
                                        title={'Do not merge'}
                                        type={'radio'}
                                        name={'mergeType'}
                                        ref={register}
                                        value={'4'}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                clearErrors('documentTypes');
                                            }
                                        }}
                                    />
                                    None
                                </label>
                            </Fieldset>
                        </div>
                        <hr style={{width: '100%'}}/>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                       {/*<RHFSelect
                            bodyStyle={{whiteSpace: 'nowrap', width: '55%' }}
                            style={{ width: '100%' }}
                            name="documentCategory"
                            label="Document Category:"
                            options={[
                                { label: 'Invoice', value: '0' },
                                { label: 'Time Sheet', value: '1' },
                                { label: 'Expense Receipts', value: '2' },
                                { label: 'Invoice Certification', value: '3' },
                                { label: 'Office Expenses', value: '4' },
                                { label: 'Invoice Account Summary', value: '5' },
                                { label: 'BOP Time Sheet', value: '3' }
                            ]}
                            register={register}
                            errors={errors}
                        />
                        <RHFSelect
                            bodyStyle={{whiteSpace: 'nowrap', width: '50%' }}
                            style={{ width: '100%' }}
                            name="documentType"
                            label="Document type"
                            options={[
                                { label: 'PDF', value: '2' },
                                { label: 'CSV', value: '1' },
                                { label: 'Excel', value: '3' }
                            ]}
                            register={register}
                            errors={errors}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '10%', marginLeft: '1rem' }}
                            text={'Add'}
                            onClick={() => onAddDocument()}
                        />*/}
                        </div>
                </div>
                <div>
                    { !!props?.invoicesDocTypes && props?.invoicesDocTypes.length > 0 && renderDocumeTypeOptions()}
                    {errors.documentTypes && <label style={{color: 'red'}}>{errors.documentTypes.message}</label>}
                </div>
                <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                    <Button
                        className="blue-hover-button"
                        type={'submit'}
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Generate'}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => props.hideDialog()}
                    />
                </div>
            </form>
        </Dialog>
    );
};

export default InvoiceDocumentCreationDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/InvoiceDocumentCreationDialog.tsx